import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router";
// importing an object with all of the named exports
import * as actions from "./duck";

import StoreFilterContainer from "../components/Filter/StoreFilterContainer";
import style from "../stylesheets/StoreFilter.module.scss";
import utility from "../services/utility";
import view from "../services/view";

import { CLOSE_MENU_PSEUDO_FACET_ID } from "../constants";

class FilterContainer extends React.Component {
  componentWillMount() {
    // load the filter
    this.props.processFilters({ dataFromServer: this.props });
  }

  componentDidMount() {
    const params = utility.constructParams({
      facets: this.props.facet_params,
      minPrice: this.props.min_price,
      maxPrice: this.props.max_price,
      term: this.props.term,
    });

    this.props.pushState(params, false, true);

    const unlisten = this.props.history.listen((location, action) => {
      if (location.state === undefined) {
        if (
          this.props.initialLocation &&
          this.props.initialLocation.search === location.search
        ) {
          this.props.handleQuery(this.props.initialLocation.state);
        }
        return;
      }

      if (action === "POP") {
        this.props.handleQuery(location.state);
      }
    });

    const filterWrapperSelector = `.${style.filterWrapper}`;
    const listenerAction = utility.listenerAction(filterWrapperSelector, () =>
      this.props.showDropdown(CLOSE_MENU_PSEUDO_FACET_ID)
    );

    this.props.handleClickListener(listenerAction);

    utility.setScreenStateOnWindowResize(() => {
      this.props.handleClickListener(listenerAction);
      this.props.setScreenSize();
    });

    if (this.props.isMobile && utility.filterApplied(this.props)) {
      view.removeFeaturedSales();
    }
  }

  componentDidUpdate() {
    if (!this.props.isMobile) {
      view.adjustDropdownWidth();
    }
  }

  render() {
    return (
      <StoreFilterContainer
        maxPrice={this.props.max_price}
        minPrice={this.props.min_price}
        nbHits={this.props.nbHits}
        handlePriceFilterClick={this.props.handlePriceFilterClick}
        handlePriceFilterInput={this.props.handlePriceFilterInput}
        facetFilters={this.props.facet_filters}
        facetParams={this.props.facet_params}
        categoryListOfFilters={this.props.categoryListOfFilters}
        categoryListWithCounts={this.props.categoryListWithCounts}
        parentFilterExists={this.props.parentFilterExists}
        isUltimateParentCategory={this.props.isUltimateParentCategory}
        handleRemoveCategoryFilter={this.props.handleRemoveCategoryFilter}
        handleCategoryFilterClick={this.props.handleCategoryFilterClick}
        slideCategoryFilters={this.props.slideCategoryFilters}
        loadFiltersAndResults={this.props.loadFiltersAndResults}
        clearPriceFilter={this.props.clearPriceFilter}
        clearAllFilters={this.props.clearAllFilters}
        clearMultiSelectFilter={this.props.clearMultiSelectFilter}
        handleFilterClick={this.props.handleFilterClick}
        selectedDropdown={this.props.selectedDropdown}
        showDropdown={this.props.showDropdown}
        showingLowestCategoryLevel={this.props.showingLowestCategoryLevel}
        facetParamsName={this.props.facet_params_name}
        categoryTargetFilter={this.props.categoryTargetFilter}
        isMobile={this.props.isMobile}
        toggleMobileFilter={this.props.toggleMobileFilter}
        mobileFilterOpened={this.props.mobileFilterOpened}
        mobileHandleFilterClick={this.props.mobileHandleFilterClick}
        mobileFacetParams={this.props.mobileFacetParams}
        min_price_input={this.props.min_price_input}
        max_price_input={this.props.max_price_input}
        expandFilter={this.props.expandFilter}
      />
    );
  }
}

const mapStateToProps = (state) => {
  const filterState = state.filterReducer;

  return {
    id: filterState.get("id"),
    name: filterState.get("name"),
    nbHits: filterState.get("nbHits"),
    term: filterState.get("term"),
    max_price: filterState.get("max_price"),
    min_price: filterState.get("min_price"),
    facet_filters: filterState.get("facet_filters"),
    facet_params: filterState.get("facet_params"),
    facet_params_name: filterState.get("facet_params_name"),
    parentFilterExists: filterState.get("parentFilterExists"),
    isUltimateParentCategory: filterState.get("isUltimateParentCategory"),
    showingLowestCategoryLevel: filterState.get("showingLowestCategoryLevel"),
    completeListOfFilters: filterState.get("completeListOfFilters"),
    categoryListOfFilters: filterState.get("categoryListOfFilters"),
    categoryListWithCounts: filterState.get("categoryListWithCounts"),
    categoryTargetFilter: filterState.get("categoryTargetFilter"),
    selectedDropdown: filterState.get("selectedDropdown"),
    isMobile: filterState.get("isMobile"),
    mobileFilterOpened: filterState.get("mobileFilterOpened"),
    mobileHandleFilterClick: filterState.get("mobileHandleFilterClick"),
    mobileFacetParams: filterState.get("mobileFacetParams"),
    min_price_input: filterState.get("min_price_input"),
    max_price_input: filterState.get("max_price_input"),
    initialLocation: filterState.get("initialLocation"),
  };
};

export default withRouter(connect(mapStateToProps, actions)(FilterContainer));
